module.exports = __webpack_public_path__ + "static/media/agile-scrum.238f3787.svg";